export default {"src":"/planos/_next/static/media/logo.a9695457.svg","height":32,"width":217,"blurWidth":0,"blurHeight":0};